import { Web } from "../Pages/Web";
import { GoogleMap } from "../components/organism/GoogleMap";
import { WebPosts } from "../components/organism/WebPosts";
import { WebReviews } from "../components/organism/WebReviews";
import { WidgetsReviews } from "../components/organism/widgets/WidgetsReviews";

export const routes = [	
	{
		path: '/web/:id',
		component: Web,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webPosts/:id',
		component: WebPosts,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webReviews/:id',
		component: WebReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/widgets/reviews/:id',
		component: WidgetsReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webMap/:id',
		component: GoogleMap,
		viewHeader: false,
		isAuthenticated: false
	}
	,
	// {
	// 	path: '/error403',
	// 	component: Error403,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
	// ,
	// {
	// 	path: '/error404',
	// 	component: Error404,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
	// ,
	// {
	// 	path: '/error500',
	// 	component: Error500,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
]